import { render } from "./CategorySlider.vue?vue&type=template&id=0ff77e4f"
import script from "./CategorySlider.vue?vue&type=script&lang=js"
export * from "./CategorySlider.vue?vue&type=script&lang=js"

import "./CategorySlider.vue?vue&type=style&index=0&id=0ff77e4f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__